/**
 * A product code is always the feed product ID plus 10000, a legacy convention carried over from
 * the Mononoth Rails application. UPS stores products in DynamoDB under the product code but keys
 * its GraphQL API on the feed product ID, applying the offset itself, so `Product.id` and the
 * `productids` argument are both feed IDs. Everything else at NOTHS speaks product codes, so this
 * package translates at its boundary and never exposes a feed ID.
 */
export const PRODUCT_CODE_OFFSET = 10000;

/**
 * Product URIs are stored in UPS as absolute URLs against the live origin in every environment,
 * QA included, so this is a property of the data rather than of the environment. Overridable on
 * the fetch in case that ever stops being true.
 */
export const PRODUCT_URI_ORIGIN = 'https://notonthehighstreet.com';
